import React from 'react';
import { Link } from 'react-router-dom';

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  return (
    <footer className={`bg-white border-t border-gray-200 ${className}`}>
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {/* Legal Links */}
          <nav className="flex flex-wrap justify-center md:justify-start space-x-6 text-sm">
            <Link
              to="/privacy"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/about"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              About
            </Link>
          </nav>

          {/* Copyright */}
          <div className="text-sm text-gray-500">
            © 2025 Vester LLC. All rights reserved.
          </div>
        </div>

        {/* Additional Legal Information */}
        <div className="mt-6 pt-6 border-t border-gray-200">
          <div className="text-xs text-gray-400 text-center space-y-2">
            <p>
              Vester uses Supabase for authentication and data storage. By using Vester, you agree to Supabase's{' '}
              <a
                href="https://supabase.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-gray-500"
              >
                Terms of Service
              </a>
              {' '}and{' '}
              <a
                href="https://supabase.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-gray-500"
              >
                Privacy Policy
              </a>
              .
            </p>
            <p>
              Investment data is provided for informational purposes only and should not be considered as financial advice.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

